import { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Button,
  TextField,
  Dialog,
  DialogContent,
} from "@mui/material";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseConsultation } from "./UseConsultation";
import { useNavigate, useLocation } from "react-router-dom";
import useBreakpoints from "../../hooks/useBreakpoints";
import ConsultationOrders from "./ConsultationOrders";
import OrderItems from "./OrderItems";
import ConsultationHistory from "./ConsultationHistory";
import Operations from "./Operations";

export default function ConsultationDetail(props) {
  let navigate = useNavigate();
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const {
    GetConsultantById,
    confirmConsultant,
    denyConsultant,
    suspendConsultant,
  } = UseConsultation();
  const [showHistory, setShowHistory] = useState(false);
  const [showOrder, setShowOrder] = useState(false);
  const [open, setOpen] = useState({ show: false, count: undefined });
  const { isSmall } = useBreakpoints();
  const [state, setState] = useState();

  useEffect(() => {
    if (location.state && location.state.id) {
      setProgress(true);
      GetConsultantById(location.state.id, (details) => {
        setState(details);
      });
    }
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: `/consulate?state=${
          location.state ? location.state.orderState : 1
        }`,

        title: "ارتباط با مشتری",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/consulate" },
          { name: "جزییات مشاوره", url: "/consulate/consultationDetails" },
        ],
      }}
    >
      {state && (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
          <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
            <Box display="grid" gap={3}>
              <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
                <Box
                  sx={{ display: "flex", gap: 2 }}
                  gridColumn={isSmall ? "span 12" : "span 4"}
                >
                  <TextField
                    fullWidth
                    value={
                      state.firstName && state.lastName
                        ? state.firstName + " " + state.lastName
                        : ""
                    }
                    label="نام و نام خانوادگی"
                    size="small"
                    variant="filled"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                {!isSmall && <Box gridColumn="span 8"></Box>}
                <Box
                  sx={{ display: "flex", gap: 2 }}
                  gridColumn={isSmall ? "span 12" : "span 3"}
                >
                  <TextField
                    fullWidth
                    value={state.mobile ? state.mobile : ""}
                    sx={{
                      input: { textAlign: "center" },
                    }}
                    label="موبایل"
                    size="small"
                    variant="filled"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                {!isSmall && <Box gridColumn="span 9"></Box>}
                <Box
                  sx={{ display: "flex", gap: 2 }}
                  gridColumn={isSmall ? "span 12" : "span 6"}
                >
                  <TextField
                    fullWidth
                    value={state.product ? state.product : "-"}
                    label="محصول"
                    size="small"
                    variant="filled"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                {!isSmall && <Box gridColumn="span 6"></Box>}
                <Box
                  sx={{ display: "flex", gap: 2 }}
                  gridColumn={isSmall ? "span 12" : "span 6"}
                >
                  <TextField
                    fullWidth
                    value={state.brand ? state.brand : "-"}
                    label="برند"
                    size="small"
                    variant="filled"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                {!isSmall && <Box gridColumn="span 6"></Box>}
                <Box
                  sx={{ display: "flex", gap: 2 }}
                  gridColumn={isSmall ? "span 12" : "span 6"}
                >
                  <TextField
                    fullWidth
                    value={state.description ? state.description : "-"}
                    label="توضیحات"
                    multiline
                    maxRows={10}
                    size="small"
                    variant="filled"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                {!isSmall && <Box gridColumn="span 6"></Box>}
                <Box
                  sx={{ display: "flex", gap: 2 }}
                  gridColumn={isSmall ? "span 12" : "span 3"}
                >
                  <TextField
                    fullWidth
                    value={state.shamsiLogdate ? state.shamsiLogdate : ""}
                    label="تاریخ"
                    sx={{
                      input: { textAlign: "center" },
                    }}
                    size="small"
                    variant="filled"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                {!isSmall && <Box gridColumn="span 9"></Box>}
                <Box gridColumn="span 12">
                  <Typography variant="subtitle1" color="secondary">
                    جزییات سفارش
                  </Typography>
                </Box>
                <Box gridColumn="span 12">
                  <TextField
                    fullWidth
                    value={
                      state.orders && state.orders[0]
                        ? state.orders[0].address
                        : ""
                    }
                    label="آدرس"
                    size="small"
                    variant="filled"
                    multiline
                    maxRows={4}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                <Box
                  gridColumn="span 12"
                  sx={{
                    display: "flex",
                    flexDirection: isSmall ? "column" : "row",
                    gap: 2,
                  }}
                >
                  <TextField
                    fullWidth
                    value={
                      state.orders && state.orders[0]
                        ? state.orders[0].city
                        : ""
                    }
                    label="شهر"
                    sx={{ width: isSmall ? "100%" : "40%" }}
                    size="small"
                    variant="filled"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TextField
                    fullWidth
                    value={
                      state.orders && state.orders[0]
                        ? state.orders[0].provine
                        : ""
                    }
                    sx={{ width: isSmall ? "100%" : "40%" }}
                    label="استان"
                    size="small"
                    variant="filled"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                <Box
                  gridColumn="span 12"
                  sx={{
                    display: "flex",
                    flexDirection: isSmall ? "column" : "row",
                    gap: 2,
                  }}
                >
                  <TextField
                    fullWidth
                    value={
                      state.orders && state.orders[0]
                        ? state.orders[0].shamsiLogdate
                        : ""
                    }
                    label="تاریخ سفارش"
                    sx={{
                      input: { textAlign: "center" },
                      width: isSmall ? "100%" : "30%",
                    }}
                    size="small"
                    variant="filled"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TextField
                    fullWidth
                    value={
                      state.orders && state.orders[0]
                        ? state.orders[0].state
                        : ""
                    }
                    sx={{ width: isSmall ? "100%" : "20%" }}
                    label="وضعیت"
                    size="small"
                    variant="filled"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                <Box gridColumn="span 12">
                  <OrderItems
                    rows={
                      state.orders && state.orders[0].items
                        ? state.orders[0].items
                        : []
                    }
                  />
                </Box>
                <Box gridColumn="span 12" sx={{ display: "flex", gap: 1 }}>
                  <Button
                    variant="contained"
                    onClick={() => setShowOrder(true)}
                  >
                    سفارشات کاربر
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => setShowHistory(true)}
                  >
                    تاریخچه کاربر
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
            }}
          >
            <Operations
              consultantID={state.id}
              description={state.description}
              orderState={location.state?.orderState}
            />
          </Box>
        </Box>
      )}

      {showOrder && (
        <ConsultationOrders
          showOrder={showOrder}
          setShowOrder={setShowOrder}
          consultantID={state.id}
        />
      )}
      {showHistory && (
        <ConsultationHistory
          showHistory={showHistory}
          setShowHistory={setShowHistory}
          consultantID={state.id}
        />
      )}
    </Detail>
  );
}
